import React from 'react';
import { Link } from 'react-router-dom';
import { useSEO } from './useSEO';

const Cancel = () => {
  useSEO({
    title: 'Payment cancelled',
    description: 'Your checkout was cancelled. Return to the Resource Hub to browse GCSE and A-Level revision materials.',
    canonicalPath: '/cancel'
  });

  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center p-8 bg-red-50">
      <h1 className="text-4xl font-bold text-red-700 mb-4">Payment Cancelled</h1>
      <p className="text-lg text-gray-700 mb-6">
        Your checkout was cancelled. No payment was taken.
      </p>
      <Link
        to="/"
        className="bg-red-600 text-white px-6 py-3 rounded hover:bg-red-700 transition"
      >
        Return to Home
      </Link>
    </div>
  );
};

export default Cancel;
